import React, { Component } from 'react';
import { string, func, bool, shape, number, oneOfType } from 'prop-types';
import cn from 'classnames';

import CustomButton from '~components/CustomButton';

import styles from './styles.module.scss';

class Tab extends Component {
  handleClick = e => {
    const { onClick, ...props } = this.props;
    const elementX = e.target.getBoundingClientRect().x;

    e.target?.parentElement?.scrollTo({ left: elementX, behavior: 'smooth' });

    onClick(props);
  };

  render() {
    const { className, active, disabled, text, id, yellowBtnStyle } = this.props;

    return (
      <CustomButton
        id={id}
        type="button"
        fullWidth
        onClick={this.handleClick}
        disabled={disabled}
        className={cn(styles.btnTab, className, {
          [styles.active]: active,
          [styles.btnTabYellow]: yellowBtnStyle,
          [styles.disabled]: disabled
        })}>
        {text}
      </CustomButton>
    );
  }
}

Tab.defaultProps = {
  className: '',
  id: undefined
};

Tab.propTypes = {
  onClick: func.isRequired,
  active: bool,
  className: string,
  disabled: bool,
  icon: shape({
    default: string.isRequired,
    active: string,
    disabled: string
  }),
  id: oneOfType([number, string]),
  overrideClasses: bool,
  text: string,
  yellowBtnStyle: bool
};

export default Tab;
